import axios from "axios";

export default axios.create({
  baseURL: "https://api.brandboxbw.com/",
  headers: {
  }
});
//http://localhost:8011/
/*"https://dev.brandboxbw.com/mpi"*/